(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["page-loader"] && !Shopify.designMode) return;
  try {
    (function() {
    var loader = document.querySelector('[data-page-loader]');
    if (!loader) return;

    function showLoader() {
      loader.classList.add('is-active');
      loader.setAttribute('aria-hidden', 'false');
    }

    function hideLoader() {
      loader.classList.remove('is-active', 'is-arriving');
      loader.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('page-loader-lock');
    }

    document.addEventListener('click', function(event) {
      var link = event.target.closest('.nav-menu__link, .site-header__logo-link, .site-header-compact__logo-link, .site-header__search-icon-btn, .site-header-compact__search-icon-btn');
      if (!link || !link.href || event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;

      var destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin) return;
      if (destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) return;

      if (window.closeNavMenu) window.closeNavMenu();
      showLoader();
      // Let the browser follow the link immediately, including normal history behavior.
    });

    document.addEventListener('submit', function(event) {
      if (event.defaultPrevented) return;
      var form = event.target.closest('.site-header__search-form, .site-header-compact__search-form, .search-page__form');
      if (form) showLoader();
      // Native form submission preserves validation, submitters and keyboard behavior.
    });

    window.addEventListener('pageshow', hideLoader);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-range-filter"] && !Shopify.designMode) return;
  try {
    class PriceRange extends HTMLElement {
    #ready = false;

    connectedCallback() {
      if (this.#ready) return;
      const thumbMin = this.querySelector('.price-range__thumb--min');
      const thumbMax = this.querySelector('.price-range__thumb--max');
      const fill = this.querySelector('.price-range__fill');
      const numMin = this.querySelector('.price-range__num--min');
      const numMax = this.querySelector('.price-range__num--max');
      const apply = this.querySelector('.price-range__apply');
      if (!thumbMin || !thumbMax || !fill || !numMin || !numMax || !apply) return;

      const rangeMax = parseFloat(this.dataset.rangeMax) || 1000;
      const rangeMaxEuros = Math.round(rangeMax / 100);

      let formatter = null;
      try {
        formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
          maximumFractionDigits: 0
        });
      } catch (error) {
        formatter = null;
      }

      const updateFill = () => {
        for (const thumb of [thumbMin, thumbMax]) {
          const euros = Math.round(thumb.value / 100);
          thumb.setAttribute('aria-valuetext', formatter ? formatter.format(euros) : String(euros));
        }
        const lo = parseFloat(thumbMin.value);
        const hi = parseFloat(thumbMax.value);
        fill.style.left = `${(lo / rangeMax) * 100}%`;
        fill.style.width = `${((hi - lo) / rangeMax) * 100}%`;
      };

      thumbMin.addEventListener('input', () => {
        if (+thumbMin.value > +thumbMax.value) thumbMin.value = thumbMax.value;
        numMin.value = Math.round(thumbMin.value / 100);
        updateFill();
      });
      thumbMax.addEventListener('input', () => {
        if (+thumbMax.value < +thumbMin.value) thumbMax.value = thumbMin.value;
        numMax.value = Math.round(thumbMax.value / 100);
        updateFill();
      });
      // Zahlenfelder in die Regler übernehmen und begrenzen (min <= max, 0 bis Höchstpreis)
      const syncMin = () => {
        const euros = Math.max(0, Math.min(+numMin.value || 0, +numMax.value || rangeMaxEuros));
        numMin.value = euros;
        thumbMin.value = euros * 100;
        updateFill();
      };
      const syncMax = () => {
        const euros = Math.min(rangeMaxEuros, Math.max(+numMax.value || 0, +numMin.value || 0));
        numMax.value = euros;
        thumbMax.value = euros * 100;
        updateFill();
      };
      const syncFromFields = (active) => {
        // Das gerade bearbeitete Feld zuerst, damit es die Gegenseite begrenzt
        if (active === numMin) {
          syncMin();
          syncMax();
        } else {
          syncMax();
          syncMin();
        }
      };
      numMin.addEventListener('change', syncMin);
      numMax.addEventListener('change', syncMax);

      for (const input of [numMin, numMax]) {
        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          syncFromFields(input);
          apply.click();
        });
      }

      apply.addEventListener('click', () => {
        syncFromFields(document.activeElement);
        const param = this.dataset.param || 'filter.p.m.price';
        const url = new URL(window.location.href);
        // Regler halten Cent, die Filter-URL erwartet Währungseinheiten
        url.searchParams.set(`${param}.gte`, Math.round(thumbMin.value / 100));
        url.searchParams.set(`${param}.lte`, Math.round(thumbMax.value / 100));
        this.dispatchEvent(new CustomEvent('price-range:apply', {
          bubbles: true,
          detail: { url }
        }));
      });

      updateFill();
      this.#ready = true;
    }
  }

  if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);
  } catch(e) { console.error(e); }
})();

})();
